function FormatedKey(key) {
  return `${import.meta.env.VITE_CONTEXT}_${key}`;
}

export class LocalStorageHelper {
  static setItem(key: string, value: any) {
    if (typeof value !== "string") {
      localStorage.setItem(FormatedKey(key), JSON.stringify(value));
    } else {
      localStorage.setItem(FormatedKey(key), value);
    }
  }
  static getItem(key: string, parse?: boolean) {
    const value = localStorage.getItem(FormatedKey(key));
    if (value && parse) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
    return value;

    return null;
  }
  static removeItem(key: string) {
    localStorage.removeItem(FormatedKey(key));
  }
}
